/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-01-29 14:33:58
 */
import instance from '@/service'
import utilsManager from '@/utils-center'
import { Infomation, Banner } from './model'
import { ResponseCode } from '@/commons/enums'
export class NewsMixinService {
  async getInfomation (menuId: string, params: any): Promise<any> {
    const result = await instance.get(`/api/v1/information/?moduleKey=app_information&menuId=${menuId}`, { params })
    // result.data.total
    return result.data.items.map((item: any) => {
      return new Infomation(item.id, item.name, item.content, item.imageUrl, utilsManager.formateDateToZh(item.createAt), item.readNum, item.linkUrl, result.data.total)
    })
  }

  async getNewsService (params: any) {
    const res = await instance.get('/api/v1/menu/homePage/', { params })
    if (res && res.data && res.data.items) {
      console.log('items', res.data.items)
      return res.data.items
    }
  }

  async informationReviewService (): Promise<any> {
    const response = await instance.get('/api/v1/home-index/config?key=web-index-banner')
    if ((response as any).code !== ResponseCode.SUCCESS) {
      return []
    }
    (response as any).data = response.data
    const data = response.data
    return data.map((item: any) => {
      const dataItemArr = item.relatedId.split('@#')
      const url = dataItemArr[0] || ''
      const link = dataItemArr[1] || ''
      const publish = dataItemArr[2] === 'true'
      return new Banner(link, url, publish, item.sort)
    })
  }
}
